<template>
  <div>
    <buybuinessdetails :id="business_id"></buybuinessdetails>
  </div>
</template>
<script>
import buybuinessdetails from "@/components/BuyBusinessDetails.vue";
export default {
  components: {
    buybuinessdetails
  },
  data () {
    return {
      business_id: 0,
    };
  },
  methods: {

  },
  created () {
    let business_id = this.$route.params.id;
    this.business_id = business_id;
  }

};
</script>
<style scoped>
</style>
